module.exports = __webpack_public_path__ + "homeowner_promo.896e2aeb418f9cedafd925d46b09ffc4.png";